import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Dropdown, Icon, Button, message } from 'antd';
import { inject, observer } from 'mobx-react';
import { Link, withRouter } from 'react-router-dom';

const logo = require('./../images/ingv_logo.png');
const logo2 = require('./../images/EPOS-White.png');
const logo3 = require('./../images/EPOS-TSU-Logo_notext.png');


const ProfileDroprown = inject('authStore')(
  withRouter(
    observer(({ authStore }) => {
      const onClick = ({ key }) => {
        switch (key) {
          case 'logout':
            message.success('You have successfully logged out, redirecting to home page...', 1.5);
            setTimeout(() => authStore.logout(), 1500);
            break;
          default:
            break;
        }
      };
      return (
        <Menu onClick={onClick}>
          <Menu.Item key="logout">
            <Icon type="logout" />
            Log Out
          </Menu.Item>
        </Menu>
      );
    })
  )
);

const HeaderProfile = ({ self }) => {
  if (!self) {
    var u = new URLSearchParams(window.location.search).get("dataset")
    return (
      <div className="header__profile">
        {/* <Link to={`/login?dataset=${u}`}>
          <Button ghost icon="login">
            Login
          </Button>
        </Link> */}
      </div>
    );
  }

  return (
    <div className="header__profile">
      {/* <Link to="/submit-dataset">
        <Button ghost icon="plus">
          Submit New Dataset
        </Button>
      </Link> */}
      <Dropdown overlay={<ProfileDroprown />} trigger={['click']}>
        <Button style={{ marginLeft: 8 }}>
          <Icon type="user" /> {self.displayName} <Icon type="down" />
        </Button>
      </Dropdown>
    </div>
  );
};
HeaderProfile.propTypes = {
  self: PropTypes.object,
};
HeaderProfile.defaultProps = {
  self: null,
};

const Header = inject('commonStore', 'userStore')(
  observer(({ commonStore, userStore, children }) => (
    <div id="header" className="flex-row flex--aligned">
      <Button
        className="menu-toggle"
        style={{ marginRight: 6 }}
        icon={commonStore.isSidebarActive ? 'menu-fold' : 'menu-unfold'}
        onClick={() => commonStore.toggleSidebar()}
      />
      
      <div className="app-header flex-row flex--aligned">
        <a href="https://www.epos-eu.org" target="_blank">
          <img
            src={logo2}
            style={{
              width: 70,
              marginRight: 10
            }}
            alt="epos logo"
          />
        </a>

        <a href="https://tsunamidata.org" target="_blank">
          <img
            src={logo3}
            style={{
              width: 40,
              marginRight: 10
              
            }}
            alt="TCS Tsunami logo"
          />
        </a>

        <a href="https://www.ingv.it/" target="_blank">
          <img
            src={logo}
            style={{
              width: 42,
            }}
            alt="ingv logo"
          />

        </a>

        
        
        
        <span className="app-header__title">Interactive Tsunami Hazard Tool</span>
      </div>
      
      <div className="flex-spacer" />
      {children}
      <HeaderProfile self={userStore.self} />
    </div>
  ))
);

Header.propTypes = {
  children: PropTypes.array,
};

Header.defaultProps = {
  children: null,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js